import React, { useContext, useState } from "react";
import logo from "../assets/images/rdlogo.png";
import { IoNewspaperOutline } from "react-icons/io5";
import { TbSend } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { PatentContext } from "../context/PatentContextProvider";
import { ContactUsModal } from "./ContactUsModal";
import BBBlogo from "../assets/images/footerlogo (1).png";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import video from "../assets/videos/rd.mp4";

const LaunchingSoon = () => {
  const [openVideo, setOpenVideo] = useState(false);
  const navigate = useNavigate();
  const { setPatentLicensingModal } = useContext(PatentContext)

  const handleContactUsModal = () => {
    setPatentLicensingModal(true);
  };
  return (
    <div>
      <>
        <section
          className="w-full bg-gradient-to-t from-[#c722256e]
via-[#ecd4bf] via-[50%]
to-[#1aaae7]
backdrop-blur-md
overflow-y-auto
min-h-screen
"
        >
          {/* 🔥 Vertical lines overlay */}
          <div className="pointer-events-none absolute inset-0 bg-[repeating-linear-gradient(90deg,rgba(255,255,255,0.09),rgba(255,255,255,0.09)_3px,transparent_4px,transparent_100px)]" />
          <div className="mx-2 mt-2 px-2 flex  items-center md:justify-end lg:gap-5 justify-between">
            <button
              type="button"
              className="
      group relative inline-flex items-center gap-2.5
      whitespace-nowrap
      rounded-xl border border-black/10
      bg-[#205285]
      w-1/2 sm:w-auto justify-center
      px-5 md:px-7 py-3.5
      text-sm font-semibold text-white
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer">
              <TbSend size={18} />
              <span className="tracking-wide" onClick={handleContactUsModal}>Drop us a line</span>
            </button>
            <img src={BBBlogo} className="p-2" />

          </div>
          <div className="relative z-10 flex  flex-col items-center justify-center px-6 text-center mt-36">
            {/* Logo */}
            <img
              src={logo}
              alt="Ask Jeeves IP"
              className="mx-auto mb-4 w-64 md:w-72"
              loading="lazy"
            />

            {/* Heading */}
            <h2
              className="text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight
             bg-gradient-to-r from-[#179bd3]  to-[#ca2326] bg-clip-text text-transparent pb-3"
            >
              Launching Soon
            </h2>

            {/* Actions */}
            {/* <div className="relative mt-14 flex flex-wrap items-center justify-center gap-4 md:gap-6 px-4"> */}
            <div className="relative mt-14 grid grid-cols-2 sm:flex mb-16 sm:flex-wrap items-center justify-center gap-4 sm:gap-6 w-full max-w-4xl">

              {/* Soft glow background */}
              <div className="absolute inset-0 -z-10 flex justify-center">
                <div className="h-20 w-full max-w-xs md:max-w-md rounded-full bg-white/20 blur-3xl" />
              </div>
              <button
                type="button"
                onClick={() => setOpenVideo(true)}
                className="col-span-2
       group relative inline-flex items-center gap-2.5
      text-xs md:text-sm
      rounded-xl border border-black/10
      bg-[#205285]
      w-full sm:w-auto justify-center
      px-5 md:px-7 py-2.5
      font-semibold text-white
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
              >
                <span className="absolute inset-0 rounded-xl bg-white/10 opacity-0 transition-opacity group-hover:opacity-100" />

                <svg
                  className="relative h-7 w-7 transition-transform duration-300 group-hover:scale-110"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M8 5v10l7-5-7-5z" />
                </svg>

                <span className="relative tracking-wide">The First To Understand, Adapt, Respond, & Overcome</span>
              </button>

              <Menu as="div" className="relative inline-block col-span-2">
                <MenuButton className="inline-flex   justify-center group   group relative  items-center gap-2 whitespace-nowrap pl-7
       rounded-xl border border-black/10
      bg-[#205285]
      px-5 md:px-7 py-3.5
      text-sm font-semibold text-white
      backdrop-blur-md
      w-full sm:w-auto 
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer">
                  Press Release
                  <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                </MenuButton>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md  bg-[#205285]/100 outline-[#205285]/100 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                >
                  <div className="py-1">
                    <MenuItem>
                      <a
                        href="https://investorshangout.com/kenneth-ohanlon-pioneering-the-future-of-digital-innovation-509688-/"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden
                    hover:bg-white/15"
                      >
                        Pioneering the Future of Digital Innovation - Investors Hangout
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="https://sg.finance.yahoo.com/news/inner-circle-acknowledges-kenneth-ohanlon-172800269.html?guccounter=1"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden hover:bg-white/15"
                      >
                        The Inner Circle acknowledges Kenneth O'Hanlon
                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="https://feature.marquiswhoswho.com/MWW_WSJ_Western_February12_2026"
                        target="_blank"
                        className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden hover:bg-white/15"
                      >
                        Marquis who's who
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </Menu>
              <div className="relative col-span-2 xl:col-span-1 flex justify-center ">
                <button
                  type="button"
                  onClick={() => navigate("/seven-pillars")}
                  className="            
      flex items-center gap-2.5
      whitespace-nowrap
      rounded-xl border border-black/10
      bg-[#205285]
      w-full justify-center
      px-5 md:px-7 py-3.5
      text-sm font-semibold text-white
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer">
                  <IoNewspaperOutline size={18} />
                  <span>O'Hanlon Center of Excellence.</span>
                </button>
              </div>
            </div>
          </div>
          <div className=" fixed w-full font-semibold  bottom-0 bg-white/15">
            <div className="flex justify-center  items-center">
              <span className="py-2">© 2026 AskJeevesRd. All Rights Reserved</span>
            </div>
          </div>
        </section>

        {/* Video Modal */}
        {openVideo && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={() => setOpenVideo(false)}
          >
            <div
              className="relative mx-4 w-full max-w-6xl rounded-2xl border border-[#121315]/40 bg-[#121315]/30 backdrop-blur-md shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setOpenVideo(false)}
                aria-label="Close video"
                className="absolute -right-4 -top-4 flex h-9 w-9 items-center justify-center rounded-full bg-[#b54950] text-white font-bold shadow-lg transition hover:scale-105 cursor-pointer"
              >
                ✕
              </button>

              <video
                src={video}
                controls
                autoPlay
                className="w-full rounded-2xl"
              />
            </div>
          </div>
        )}
      </>
      <ContactUsModal />
    </div>
  );
};

export default LaunchingSoon;
